module.exports = __webpack_public_path__ + "img/subtitle2.1ffc8e87.png";